import { Component, OnInit } from '@angular/core';

import { SpinnerService } from '../../../services/spinner.service';

@Component({
    selector: 'app-category-list',
    templateUrl: './category-list.component.html',
    styleUrls: ['./category-list.component.css']
})
export class CategoryListComponent implements OnInit {

    newCat: any = {
        name: '',
        parent: ''
    };
    catList: any[] = [
        {
            name: 'Salaire',
            parent: ''
        },
        {
            name: 'Logement',
            parent: ''
        },
        {
            name: 'Chambre',
            parent: 'Logement'
        },
        {
            name: 'Parking',
            parent: 'Logement'
        }
    ];

    constructor(private spinner: SpinnerService) { }

    ngOnInit() {
    }

    editCat(cat: any) {
        delete cat.edit;
        console.log(cat);
    }
}
